<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('CargoMsg.Cargo_WeightHandling')"
    width="1200px"
    top="5vh"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    class="main-content"
  >
    <div class="section" style="width: 100%">
      <el-form
        label-width="80px"
        label-position="left"
        style="width: 100%;"
      >
        <div style="display: flex">
          <el-form-item label-width="250px" :label="$t('CargoMsg.Cargo_Tip')" />
          <el-form-item :label-position="'right'" label-width="50px" :label="$t('CargoMsg.Cargo_Warehouse')">
            <el-cascader
              v-model="from.cargoTerminalOperation"
              no="cargoTerminalOperation"
              style="width: 100%;"
              :props="{ checkStrictly: true }"
              :options="cargoTerminalOperationArray"
              clearable
              @change="p=> {cargoTerminalOperationChange(p)}"
            />
          </el-form-item>
        </div>
      </el-form>
      <div style="display: flex">
        <div style="text-align: left; display: flex; width: 100%">
          <el-input v-model="page.inputText" style="width: 550px;padding-right: 5px;" class="input-border" no="inputText" @input="inputTextChange" @keyup.enter.native="okHandler" />
          <div style="padding-right: 5px; text-align: left;">
            <div style="padding-bottom: 3px">
              <el-button type="primary" @click="okHandler">{{ $t('SeaExport.Confirm') }}</el-button>
            </div>
            <div>
              <el-button @click="resetHandler">{{ $t('CargoMsg.Cargo_Reset') }}</el-button>
            </div>
          </div>
          <el-button @click="onCancel">{{ $t('CargoMsg.Cargo_DisableOpen') }}</el-button>
        </div>
        <div style="text-align: right; width: 30%">
          <el-button type="primary" style="height: 60px" @click="readScaleHandler(0)">{{ $t('CargoMsg.Cargo_ReadScale') }}</el-button>
          <el-button type="primary" style="height: 60px" @click="takePhotoHandler">{{ $t('CargoMsg.Cargo_TakePhoto') }}</el-button>
          <el-button type="success" style="height: 60px" @click="saveHandler">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
        </div>
      </div>
    </div>
    <div style="display: flex; width: 100%;">
      <div class="section" style="width: 40%;">
        <el-form
          label-position="left"
          label-width="80px"
          style="width: 100%;"
        >
          <div style="height:30px;vertical-align: middle;">
            <span style="font-weight:bold; font-size: 20px; padding-right: 5px">{{ $t('CargoMsg.Cargo_WeightRecord') }}</span>
            <el-button @click="emptyCancel">{{ $t('CargoMsg.Cargo_Empty') }}</el-button>
            <el-button @click="historyHandler">{{ $t('CargoMsg.Cargo_History') }}</el-button>
          </div>
          <div class="scrollable-div">
            <table class="table" style="width: 100%; table-layout: fixed;">
              <!-- 表格行和单元格 -->
              <tbody>
                <div v-for="(item, index) in page.list" :key="index">
                  <tr style="width: 100%">
                    <td colspan="2" style="width: 50%;">{{ item.serialNumber }}</td>
                    <td colspan="2" style="width: 50%;">{{ $t('CargoMsg.Cargo_Weighing') + item.weighbridgeWeight + 'KG' }}</td>
                  </tr>
                  <tr>
                    <td colspan="4">{{ item.warehouseNo }}</td>
                  </tr>
                  <tr style="width: 100%">
                    <td style="width: 200px">{{ $t('CargoMsg.Cargo_TareWeight') + item.tareWeight }}</td>
                    <td style="width: 200px">{{ $t('CargoMsg.Cargo_NetGrossWeight') + item.weight + ' KG' }}</td>
                    <td style="width: 200px">{{ $t('CargoMsg.Cargo_ItemsNBR') + item.quantity }}</td>
                    <td style="width: 200px">{{ $t('CargoMsg.Cargo_GrossWeight2') + item.grossWeight }}</td>
                  </tr>
                  <hr>
                </div>

              </tbody>
            </table>
          </div>

        </el-form>
      </div>
      <div style="padding-right: 5px" />
      <div class="section" style="width: 35%;">
        <el-form
          label-position="left"
          label-width="80px"
          style="width: 100%;"
        >
          <div style="height:30px;vertical-align: middle;">
            <span style="font-weight:bold; font-size: 20px; padding-right: 5px">{{ this.$t('CargoMsg.Cargo_ScalePhoto') }}</span>
            <div style="padding-top: 6px" />
            <div class="scrollable-div">
              <div v-for="(item, index) in photosList" :key="index">
                <img
                  :src="item"
                  style="width: 370px; height: 250px"
                >
              </div>
            </div>
          </div>
        </el-form>
      </div>
      <div style="padding-right: 5px" />
      <div class="section" style="width: 24%;">
        <el-form
          label-position="left"
          label-width="80px"
          style="width: 100%;"
        >
          <div style="height:30px;vertical-align: middle;">
            <span style="font-weight:bold; color: blue; font-size: 20px; padding-right: 5px">{{ this.$t('CargoMsg.Cargo_ScaleReading') + '(KG)' }}</span>
            <el-checkbox v-model="page.weighbridgeReading" no="weighbridgeReading" />
          </div>
          <el-form-item label-width="1px">
            <auto-number-input
              v-if="!page.weighbridgeReading"
              v-model="from.weighbridgeNo"
              no="weighbridgeReading"
              :precision="1"
              :min="0"
              @change="p => {weightChange(p)}"
            />
            <span v-if="page.weighbridgeReading" style="font-weight:bold;font-size: 18px;color: blue">{{ from.weighbridgeNo }}</span>
          </el-form-item>
          <hr>

          <div style="padding-top: 5px; padding-bottom: 5px">
            <span style="font-weight:bold; font-size: 24px; padding-right: 5px">{{ this.$t('CargoMsg.Cargo_WeightedInfo') }}</span>
          </div>
          <span style="font-weight:bold; font-size: 20px;">{{ from.weighbridgeNoSum || '--' }}KG</span> <span style="font-weight:bold; font-size: 20px;padding-left: 20px">{{ from.tSum || '--' }}{{ this.$t('CargoMsg.Cargo_Pallet3') }}</span>

          <div style="display: flex">
            <el-form-item label-width="100px" :label="this.$t('CargoMsg.Cargo_ItemsNBR')" />
            <el-form-item label-width="100px" :label="this.$t('CargoMsg.Cargo_Pallet2')" />
            <el-form-item label-width="100px" :label="this.$t('CargoMsg.Cargo_TareWeight')+ '(KG)'" />
          </div>
          <div style="display: flex">
            <auto-number-input
              v-model="from.quantity"
              no="quantity"
              style="width: 100px;"
              :precision="0"
              :min="0"
            />
            <cargo-advance-select
              no="palletNo"
              :select-type="selectTypeNames.basic_data_PalletConfiguration"
              filterable
              :clearable="true"
              style="width: 100px;"
              :static-options="palletConfigurationList"
              :default-value="from.palletNo"
              @parentCallBack="p=>{from.palletNo=p.value; palletNoChange(p)}"
            />
            <auto-number-input
              v-model="from.tareWeight"
              no="tareWeight"
              style="width: 120px;"
              disabled
              :precision="0"
              :min="0"
            />
          </div>
          <div style="display: flex;padding-top: 10px">
            <span style="font-weight:bold; font-size: 24px;">{{ this.$t('CargoMsg.Cargo_NetGrossWeight') + '(KG)' }}</span>
          </div>
          <span style="font-weight:bold; font-size: 40px;color: #66b966">{{ from.weight }}</span>

          <div style="display: flex">
            <el-form-item label-width="100px" :label="this.$t('CargoMsg.Cargo_GrossWeight2')" />
          </div>
          <div style="display: flex">
            <auto-number-input
              v-model="from.grossWeight"
              no="quantity"
              style="width: 100px;"
              :precision="0"
              :min="0"
              @input="p => {grossWeightChange(p)}"
            />
          </div>
        </el-form>
      </div>
    </div>
    <div slot="footer" style="text-align: right">
      <el-button type="default" @click="onCancel">{{ $t('CargoMsg.Cargo_Close') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>

import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect.vue'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput.vue'
import { getUserInfo } from '@/utils/auth'
import DateUtils from '@/utils/dateUtils'
import { queryDataBySerialNumberFunc } from '@/api/warehouseIn/warehouseIn'
import { serial } from '@/components/Cargo/FrontEndWarehouse/components/util/serial/getWeight'
import { saveWeighingProcessingFunc, takePhotosFunc } from '@/api/AirExport/airExportJob'
import { getCacheListByKey } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import lodash from 'lodash'
import $store from '@/store'
import * as NumberUtils from '@/utils/NumberUtils'
import { getLoading } from '@/utils/utilBaseElement'
import { PriceUtils } from '@/class/cargo/model/utils/PriceUtils'
import { AE } from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'WeightHandling',
  components: { AutoNumberInput, cargoAdvanceSelect },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      gridApi: null,
      selectTypeNames: TYPE_NAMES,
      port: {},
      addKey: 'weightHandling_',
      palletConfigurationList: [],
      cargoTerminalOperationArray: [],
      photosList: [], // 拍照照片
      photosErrorList: ['KeyNull', 'TokenNull', 'CameraNull'], // 拍照照片异常情况
      page: {
        list: [], // 托盘历史
        inputText: '', // 录入的进仓编号 或者 流水号
        weighbridgeReading: true,
        queryDone: false // 是否查询过
      },
      from: {
        uuid: '',
        warehouseNo: '', // 进仓编号
        cargoTerminalOperation: '', // 页面临时记值字段
        warehouse: '', // 仓库名称
        weighbridgeNo: '', // 磅重
        weighbridgeNoSum: '', // 已磅重
        tSum: '', // 托
        palletNo: '', // 托盘编号
        quantity: 0, // 件数
        singleWeight: 0, // 单件重量
        tareWeight: 0, // 皮重
        grossWeight: 0, // 配重
        weight: 0 // 净毛重
      },
      selectAirportCargoTerminal: null, // 当前选择的仓库
      selectScaleConfiguration: null, // 当前选择的地磅和摄像头配置
      rowData: []
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('close', val)
        }
      }
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.cargoTerminalOperationArray = []
      const warehouseOperations = getCacheListByKey(basicCacheKeys.basic_data_AirportCargoTerminal)
        .filter(item => item.dataType === 1 && !item.deletionFlag && item.orderType === AE.code)
      const list = lodash.cloneDeep(warehouseOperations)
      for (const data of list) {
        const object = {}
        object.label = data.warehouseName
        object.value = data.uuid
        object.warehouseName = data.warehouseName
        object.children = []
        if (data.scaleConfigurationList && data.scaleConfigurationList.length > 0) {
          for (const childrenData of data.scaleConfigurationList) {
            const childrenObject = {}
            childrenObject.label = childrenData.scaleIdentifier + '(' + childrenData.baudRate + ')'
            childrenObject.value = childrenData.uuid
            object.children.push(childrenObject)
          }
        }
        this.cargoTerminalOperationArray.push(object)
      }
    },
    // 拿到可用托盘
    getPalletConfigurations() {
      let warehouseInUuid = ''
      if (this.selectAirportCargoTerminal) {
        warehouseInUuid = this.selectAirportCargoTerminal.uuid
      }
      // 1.根据当前选择的仓库过滤 2.托盘状态未删除的。3.循环托盘或者 回收托盘且未被占用
      // 当前正在用的默认放出来
      this.palletConfigurationList = getCacheListByKey(basicCacheKeys.basic_data_PalletConfiguration).filter(p => (!p.deletionFlag &&
          (p.recycleType === 0 || (p.recycleType === 1 && p.palletStatus !== 2)) && p.airportCargoTerminalUuid === warehouseInUuid))
    },
    onCancel() {
      this.$emit('close')
    },
    okHandler() {
      if (!this.page.inputText) {
        return
      }
      queryDataBySerialNumberFunc({ serialNumber: this.page.inputText }).then(res => {
        if (res.data) {
          this.queryDone = true // 查询过才能保存
          const w = res.data
          const wdList = w.warehouseInDetailList
          this.from.uuid = w.uuid
          this.from.warehouseNo = w.warehouseNo
          if (!this.from.uuid) {
            this.from.warehouseNo = this.page.inputText
          }
          this.from.weighbridgeNoSum = 0
          this.from.tSum = 0
          this.from.lob = 'AE'
          this.photosList = []
          if (wdList) {
            let weighbridgeNoSum = 0
            for (const wd of wdList) {
              weighbridgeNoSum += NumberUtils.ToFixed2(wd.weighbridgeWeight)
            }
            this.from.weighbridgeNoSum = NumberUtils.ToFixed2(weighbridgeNoSum)
            this.from.tSum = wdList.length
          }
        }
      })
    },
    // 保存
    saveHandler() {
      if (!this.selectAirportCargoTerminal) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CheckWarehouseInConfig'))
        return
      }
      if (!this.queryDone) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseConfirm'))
        return
      }
      if (!this.from.weighbridgeNo) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseFill') + this.$t('CargoMsg.Cargo_Weighing'))
        return
      }
      if (!this.from.quantity) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseEnterPieceCount'))
        return
      }
      const params = {}
      params.uuid = this.from.uuid
      params.warehouseNo = this.from.warehouseNo
      params.airportCargoTerminalUuid = this.selectAirportCargoTerminal.uuid
      params.warehouse = this.selectAirportCargoTerminal.warehouseName
      params.warehouseInDate = new Date()
      params.lob = 'AE'
      const wd = {
        weighbridgeWeight: this.from.weighbridgeNo,
        tareWeight: this.from.tareWeight,
        weight: this.from.weight,
        quantity: this.from.quantity,
        palletNo: this.from.palletNo,
        grossWeight: this.from.grossWeight,
        singleWeight: this.from.singleWeight
      }
      params.warehouseInDetailList = [wd]
      params.photosList = this.photosList
      params.branchId = $store.getters.currentOfficeId
      saveWeighingProcessingFunc(params).then(res => {
        if (res.data) {
          this.$message.success(this.$t('CargoMsg.Cargo_SaveSucceed'))
          const w = res.data
          const data = {
            serialNumber: w.serialNumber, // 流水号
            warehouseNo: w.warehouseNo, // 进仓编号
            weighbridgeWeight: wd.weighbridgeWeight, // 磅重
            tareWeight: wd.tareWeight, // 皮重
            weight: wd.weight, // 净毛重
            quantity: wd.quantity, // 件数
            grossWeight: wd.grossWeight, // 配重
            orderTime: new Date().getTime()
          }
          if (!this.page.list) {
            this.page.list = []
          }
          this.page.list.push(data)

          this.page.list.sort((a, b) => b.orderTime - a.orderTime)
          this.setHistory()

          // 初始化页面
          this.from = PriceUtils.resetFilter(this.from)
          this.page.inputText = ''
          this.photosList = []
          this.queryDone = false
        }
      })
    },
    cargoTerminalOperationChange(p) {
      this.selectAirportCargoTerminal = null
      this.selectScaleConfiguration = null

      this.from.cargoTerminalOperation = ''
      if (p && p.length > 0) {
        const [uuid, cUuid] = p
        const warehouseOperations = getCacheListByKey(basicCacheKeys.basic_data_AirportCargoTerminal)
          .filter(item => item.uuid === uuid)

        if (warehouseOperations.length > 0) {
          const wo = warehouseOperations[0]
          this.selectAirportCargoTerminal = { ...wo }
          if (wo.scaleConfigurationList && cUuid) {
            const sc = wo.scaleConfigurationList.filter(item => item.uuid === cUuid)
            if (sc.length > 0) {
              this.selectScaleConfiguration = { ...sc[0] }
            }
          }
        }
      }
      this.getPalletConfigurations()
    },
    // 读磅
    readScaleHandler(n) {
      if (!this.selectScaleConfiguration) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SelectScales'))
        return
      }
      serial(this.selectScaleConfiguration.baudRate, this.selectScaleConfiguration.parityBit).then(res => {
        if (res === undefined && n < 5) {
          n++
          this.readScaleHandler(n)
        } else {
          this.from.weighbridgeNo = Number(res) || 0
          this.weightChange(this.from.weighbridgeNo)
          // 开启了自动拍照
          if (this.selectScaleConfiguration.autoPhotoTaking) {
            this.takePhotoHandler()
          }
        }
      })
    },
    // 拍照
    takePhotoHandler() {
      if (!this.selectScaleConfiguration) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SelectScales'))
        return
      }
      this.loading = getLoading()
      this.photosList = []
      const params = {}
      params.anyStr = this.selectScaleConfiguration.uuid
      takePhotosFunc(params).then(res => {
        if (res.data) {
          if (this.photosErrorList.includes(res.data)) {
            this.$message.warning(this.$t('CargoMsg.Cargo_' + res.data))
          } else {
            this.photosList = JSON.parse(res.data)
          }
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    inputTextChange(val) {
      if (val) {
        this.page.inputText = val.toUpperCase() || ''
      } else {
        this.page.inputText = ''
      }
    },
    // 设置皮重
    palletNoChange(p) {
      this.from.tareWeight = 0
      if (p) {
        this.from.tareWeight = Number(p.palletTareWeight)
      }
      this.weightChange(this.from.weighbridgeNo)
    },
    grossWeightChange(e) {
      this.from.grossWeight = e
      this.weightChange(this.from.weighbridgeNo)
    },
    // 重量改变
    weightChange(e) {
      this.from.weighbridgeNo = e
      // 净毛重 = 地磅重量 - 皮重 + 配重
      this.from.weight = NumberUtils.ToFixed2(Number(this.from.weighbridgeNo || 0) - Number(this.from.tareWeight || 0) + Number(this.from.grossWeight || 0), 1)
      // 单件重量 = 重量/件数
      if (this.from.quantity && this.from.weight) {
        this.from.singleWeight = NumberUtils.ToFixed2(Number(this.from.weight) / Number(this.from.quantity), 2)
      }
    },
    // 重置
    resetHandler() {
      this.page.inputText = ''
    },
    setHistory() {
      const currentUserInfo = getUserInfo()
      const time = DateUtils.customFormat(new Date(), 'YYYY-MM-DD')

      const historyList = localStorage.getItem(`weightHandling_${currentUserInfo.tenantId}_${currentUserInfo.userId}_${time}`)
      const seenOrderTimes = new Set()
      const historyLists = [...this.page.list, ...(JSON.parse(historyList) || [])].filter(item => {
        if (seenOrderTimes.has(item.orderTime)) {
          return false
        } else {
          seenOrderTimes.add(item.orderTime)
          return true
        }
      })
      localStorage.setItem(`weightHandling_${currentUserInfo.tenantId}_${currentUserInfo.userId}_${time}`, JSON.stringify(historyLists))
    },
    // 清空
    emptyCancel() {
      this.page.list = []
    },
    historyHandler() {
      const currentUserInfo = getUserInfo()
      const time = DateUtils.customFormat(new Date(), 'YYYY-MM-DD')
      const historyList = localStorage.getItem(`weightHandling_${currentUserInfo.tenantId}_${currentUserInfo.userId}_${time}`)
      this.page.list = JSON.parse(historyList)
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .input-border.el-input--mini .el-input__inner {
  height: 60px;
  font-size: 30px;
  line-height: 28px;
}
.centered-cell {
  text-align: center; /* 文字居中对齐 */
  width: 30%;
}
.scrollable-div {
  width: 100%;
  height: 600px;
  overflow-y: auto;
  border: 1px solid #ccc;
  padding: 10px;
  margin: 20px auto;
  background-color: #f9f9f9;
  border-radius: 8px;
}
/* 定制滚动条样式 */
.scrollable-div::-webkit-scrollbar {
  width: 6px; /* 设置滚动条的宽度 */
}
.scrollable-div::-webkit-scrollbar-track {
  background-color: transparent; /* 滚动条轨道透明 */
}
.scrollable-div::-webkit-scrollbar-thumb {
  background-color: #888; /* 滚动条滑块颜色 */
  border-radius: 3px; /* 滚动条滑块圆角 */
}
.scrollable-div::-webkit-scrollbar-thumb:hover {
  background-color: #555; /* 滚动条滑块悬停时的颜色 */
}
</style>
